const DEFAULT_MESSAGE = "Request failed";
const DEFAULT_CODE = "SERVICE_ERROR";

export const normalizeServiceError = (error, fallback = {}) => {
  if (error?.message && error?.code && typeof error?.status === "number") {
    return {
      ...error,
      response:
        error?.response ||
        (error?.details ? { status: error.status, data: error.details } : undefined),
      apiName: error?.apiName || error?.details?.apiName || null,
    };
  }

  const details = error?.response?.data || fallback.details || null;
  const status = error?.response?.status || fallback.status || 500;
  const apiMessage =
    typeof error?.response?.data?.message === "string"
      ? error.response.data.message.trim()
      : "";
  const message = apiMessage || fallback.message || error?.message || DEFAULT_MESSAGE;
  const code = fallback.code || DEFAULT_CODE;

  return {
    message,
    code,
    status,
    details,
    apiName: details?.apiName || fallback.apiName || null,
    response: error?.response || (details ? { status, data: details } : undefined),
  };
};

export const throwServiceError = (error, fallback) => {
  throw normalizeServiceError(error, fallback);
};